
function setCaretPosition(elem, caretPos) {

    if (elem.length) {
        elem = elem[0];
    }

    if (elem != null) {
        if (elem.createTextRange) {
            var range = elem.createTextRange();
            range.move('character', caretPos);
            range.select();
        } else {
            if (elem.selectionStart) {
                elem.focus();
                elem.setSelectionRange(caretPos, caretPos);
            } else
                elem.focus();
        }
    }
}

function getCaretPosition(el) {

    if (el.length) {
        el = el[0];
    }

    var end = 0,
        normalizedValue,
        range,
        textInputRange,
        len,
        endRange;

    if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
        return el.value[el.selectionEnd - 1] == "."? el.selectionEnd + 1 : el.selectionEnd;
    } else {
        range = document.selection.createRange();

        if (range && range.parentElement() === el) {
            len = el.value.length;
            normalizedValue = el.value.replace(/\r\n/g, "\n");

            // Create a working TextRange that lives only in the input
            textInputRange = el.createTextRange();
            textInputRange.moveToBookmark(range.getBookmark());

            // Check if the start and end of the selection are at the very end
            // of the input, since moveStart/moveEnd doesn't return what we want
            // in those cases
            endRange = el.createTextRange();
            endRange.collapse(false);

            if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                return len;
            } else {
                if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                    return len;
                } else {
                    return (-textInputRange.moveEnd("character", -len)) + (normalizedValue.slice(0, end).split("\n").length - 1);
                }
            }
        }
    }
    return 0;
}
